import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { DisplayMode, SelectBox, TimeApiService } from 'cbc-shared-lib';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators, } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CodeConversionMstDto, ExtractionconditionInfoDto, Sgkc027aResponse } from 'sg-api';
import { PreSelectBox } from '../../../../../sg-kc-shared/constants/preSelectBox';
import { EnergyTypeCode } from '../../../../../sg-kc-shared/constants/energyTypeCode ';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';

/**
 * スライド調整単価表検索画面(検索条件)
 * @export
 * @class Sgkc031dSlideTankaSearchConditionComponent
 * @implements { OnInit, OnDestroy, OnChanges }
 */
@Component({
    selector: 'app-sgkc031d-slide-tanka-search-condition',
    templateUrl: './sgkc031d-slide-tanka-search-condition.component.html',
    styleUrl: './sgkc031d-slide-tanka-search-condition.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc031dSlideTankaSearchConditionComponent implements OnInit, OnDestroy, OnChanges {

    /** 各必須項目の初期値 */
    readonly DEFAULT_SELECT_VALUE = " ";

    /** 検索ボタン押下イベント */
    @Output() onClickSearchEvent = new EventEmitter<void>();
    /** クリアボタン押下イベント */
    @Output() onClickClearEvent = new EventEmitter<void>();
    /** スライド調整単価表承認権限取得APIレスポンス */
    @Input() sgkc027aResponse: Sgkc027aResponse;
    /** コード変換マスタレスポンス */
    @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
    /** 画面表示モード */
    @Input() mode: string

    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;
    /** 抽出条件情報リスト */
    extractionConditionInformationList: ExtractionconditionInfoDto[] = [];
    /** 検索情報格納FormGroup */
    slideTankaConditionInfo: UntypedFormGroup;
    /** 会社 */
    companycode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** エネルギー種別 */
    energyClscode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 承認部署 */
    apprvAuthorityCode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** LP販売形態 */
    lpSalesformcode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 適用開始年月 */
    applyYmStart: UntypedFormControl = new UntypedFormControl({ value: '', disabled: false }, Validators.required);
    /** 適用終了年月 */
    applyYmEnd: UntypedFormControl = new UntypedFormControl({ value: '', disabled: false });
    /** ステータス */
    apprvStatuscode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });

    /** コード変換マスタから受け取る会社名のセレクトボックスデータ */
    preCompanyTypeList: PreSelectBox[] = [];
    /** コード変換マスタから受け取るエネルギー種別のセレクトボックスデータ */
    preEnergyTypeList: PreSelectBox[] = [];
    /** コード変換マスタから受け取るLP販売形態のセレクトボックスデータ */
    preLpSalesFormTypeList: PreSelectBox[] = [];
    /** 単価表承認権限取得APIから受け取る承認部門のセレクトボックスデータ */
    preApprovalTypeList: PreSelectBox[] = [];
    /** 単価表承認権限取得APIから受け取る承認部門のセレクトボックスデータ */
    preStatTypeList: PreSelectBox[] = [];

    /** エネルギー種別のセレクトボックスデータ */
    energyTypeList: SelectBox[] = [];
    /** 会社名 */
    companyTypeList: SelectBox[] = [];
    /** LP販売形態 */
    lpSalesFormTypeList: SelectBox[] = [];
    /** 承認部門 */
    approvalTypeList: SelectBox[] = [];
    /** 契約種別のセレクトボックスデータ */
    slideTypeList: SelectBox[] = [];
    /** 承認ステータスリストのセレクトボックスデータ */
    statTypeList: SelectBox[] = [];

    /** 
    * コンストラクタ
    * @param {FormBuilder} fb
    * @param {FormGroupDirective} parent
    * @param {ActivatedRoute} route
    * @param {TimeApiService} timeApiService
    * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    constructor(
        private fb: UntypedFormBuilder,
        private parent: FormGroupDirective,
        private route: ActivatedRoute,
        private timeApiService: TimeApiService,
    ) { }

    /** 
    * 初期処理
    * @memberof Sgkc031dSlideTankaTableSearchConditionComponent
    */
    ngOnInit(): void {
        this.slideTankaConditionInfo = this.fb.group({
            companycode: this.companycode,
            energyClscode: this.energyClscode,
            lpSalesformcode: this.lpSalesformcode,
            apprvAuthorityCode: this.apprvAuthorityCode,
            applyYmStart: this.applyYmStart,
            applyYmEnd: this.applyYmEnd,
            apprvStatuscode: this.apprvStatuscode,
        });
        this.parentForm = this.parent.form;
        this.parentForm.addControl('slideTankaConditionInfo', this.slideTankaConditionInfo);
    }

    /**
    * コンポーネント破棄時の処理
    * @memberof Sgkc031dSlideTankaTableSearchConditionComponent
    */
    ngOnDestroy(): void {
        if (this.parentForm) {
            this.parentForm.clearValidators();
            this.parentForm.updateValueAndValidity();
            this.parentForm.removeControl('slideTankaConditionInfo');
        }
    }

    /**
    * プロパティが変更されたときに、その変更に関する情報を提供する。
    * @param {SimpleChanges} changes
    * @memberof Sgkc031dSlideTankaTableSearchConditionComponent
    */
    ngOnChanges(changes: SimpleChanges) {
        // 対象プロパティが変更された場合のみ処理する
        if (changes.codeConversionMstMap && this.codeConversionMstMap) {
            this.preCompanyTypeList = this.getSelectBoxFromCodeConversionMst("S900020");
            this.preEnergyTypeList.push(...this.getSelectBoxFromCodeConversionMst("S100020"));
            this.preLpSalesFormTypeList.push(...this.getSelectBoxFromCodeConversionMst("S100110"));
            this.preStatTypeList = this.getSelectBoxFromCodeConversionMst("S100031");
        }
        if (changes.sgkc027aResponse && this.sgkc027aResponse) {
            // 抽出条件情報リスト
            this.extractionConditionInformationList = this.sgkc027aResponse.extractionconditionInformationlist;
            // 承認部門のセレクトボックスデータ
            this.preApprovalTypeList = this.sgkc027aResponse.apprvAuthorityInformationlist.
                map(data =>
                ({
                    value: String(data.tankaauthorityManagementid),
                    viewValue: data.tankaauthorityManagementname,
                    hyojiRowTurn: String(data.hyojiTurn)
                }));
        }
        if (this.codeConversionMstMap && this.sgkc027aResponse) {

            this.slideTankaConditionInfo.reset();
            this.setSelectBox();
        }
    }

    /** 
     * 会社セレクトボックスが変更されたときの処理
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    onChangeCompany(): void {
        // 会社コードの以降のフォームを非活性かつ値を初期値にする。
        this.slideTankaConditionInfo.controls['energyClscode'].disable();
        this.slideTankaConditionInfo.controls['energyClscode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.slideTankaConditionInfo.controls['lpSalesformcode'].disable();
        this.slideTankaConditionInfo.controls['lpSalesformcode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].disable();
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].setValue(this.DEFAULT_SELECT_VALUE);
        // エネルギー種別のセレクトボックスデータを設定する
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('slideTankaConditionInfo.companycode')?.value
        // 単価表承認権限取得APIで取得したデータを選択した会社名に一致するデータだけ残す。
        const companyfilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType; // companycodeが一致するかチェック
        });
        // companyfilteredListをもとに、エネルギー種別のセレクトボックスデータを作成
        const energyTypeArray: string[] = companyfilteredList.map(dto => dto.energyClscode);
        this.energyTypeList = this.makeSelectBoxData(energyTypeArray, this.preEnergyTypeList);
        // リストが複数件存在するときエネルギーのセレクトボックスを活性化
        if (this.energyTypeList.length > 1) {
            this.slideTankaConditionInfo.controls['energyClscode'].enable();
        } else if (this.energyTypeList.length === 1) {// リストが1件のときエネルギーのセレクトボックスを活性化、選択を確定
            this.slideTankaConditionInfo.controls['energyClscode'].enable();
            this.slideTankaConditionInfo.controls['energyClscode'].setValue(this.energyTypeList[0].value);
            this.onChangeEnergy();
        }
    }

    /** 
     * エネルギー種別セレクトボックスが変更されたときの処理
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    onChangeEnergy(): void {
        // エネルギー種別以降のフォームを非活性かつ値を初期値にする。
        this.slideTankaConditionInfo.controls['lpSalesformcode'].disable();
        this.slideTankaConditionInfo.controls['lpSalesformcode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].disable();
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].setValue(this.DEFAULT_SELECT_VALUE);
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('slideTankaConditionInfo.companycode')?.value
        // 選択したエネルギー種別コードを取得
        const energyType = this.parentForm.get('slideTankaConditionInfo.energyClscode')?.value;

        // 単価表承認権限取得APIで取得したデータを選択した会社名とエネルギー種別コードに一致するデータだけ残す。
        const energyFilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType && dto.energyClscode === energyType;
        });

        // エネルギー種別がLPガスの場合
        if (energyType === EnergyTypeCode.lpGas) {
            // LP販売形態のセレクトボックスを設定
            // energyFilteredListをもとに、LP販売形態のセレクトボックスデータを作成
            const lpSalesFormTypeArray: string[] = energyFilteredList.map(dto => dto.lpSalesformcode);
            this.lpSalesFormTypeList = this.makeSelectBoxData(lpSalesFormTypeArray, this.preLpSalesFormTypeList)
            // リストが複数件存在するときLP販売形態のセレクトボックスを活性化
            if (this.lpSalesFormTypeList.length > 1) {
                this.slideTankaConditionInfo.controls['lpSalesformcode'].enable();
            } else if (this.lpSalesFormTypeList.length === 1) {// リストが1件のときエネルギーのLP販売形態を活性化、選択を確定
                this.slideTankaConditionInfo.controls['lpSalesformcode'].enable();
                this.slideTankaConditionInfo.controls['lpSalesformcode'].setValue(this.lpSalesFormTypeList[0].value);
                this.onChangeLpSalesForm();
            }
        } else {// エネルギー種別がLPガス以外
            // 承認部門のセレクトボックスを設定
            // energyFilteredList をもとに、承認部門のセレクトボックスデータを作成
            const approvalTypeArray: string[] = energyFilteredList.map(dto => String(dto.apprvTankaauthorityManagementid));
            this.approvalTypeList = this.makeSelectBoxData(approvalTypeArray, this.preApprovalTypeList);
            // リストが複数件存在するとき承認部門のセレクトボックスを活性化
            if (this.approvalTypeList.length > 1) {
                this.slideTankaConditionInfo.controls['apprvAuthorityCode'].enable();
            } else if (this.approvalTypeList.length === 1) {
                this.slideTankaConditionInfo.controls['apprvAuthorityCode'].enable();
                this.slideTankaConditionInfo.controls['apprvAuthorityCode'].setValue(this.approvalTypeList[0].value);
            }
        }
    }

    /** 
     * LP販売形態セレクトボックスが変更されたときの処理
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    onChangeLpSalesForm(): void {
        // LP販売形態以降のフォームを非活性かつ値を初期値にする。
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].disable();
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].setValue(this.DEFAULT_SELECT_VALUE);
        // 承認部門を選択
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('slideTankaConditionInfo.companycode')?.value
        // 選択したエネルギー種別コードを取得
        const energyType = this.parentForm.get('slideTankaConditionInfo.energyClscode')?.value;
        // 選択したLP販売形態を取得
        const lpSalesFormType = this.parentForm.get('slideTankaConditionInfo.lpSalesformcode')?.value;

        // 単価表承認権限取得APIで取得したデータを選択した会社名、エネルギー種別コード、LP販売形態に一致するデータだけ残す。
        const lpSalesformTypeFilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType &&
                dto.energyClscode === energyType &&
                dto.lpSalesformcode === lpSalesFormType;
        });
        // lpSalesFormFilteredListをもとに、承認部門のセレクトボックスデータを作成
        const approvalTypeArray: string[] = lpSalesformTypeFilteredList.map(dto => String(dto.apprvTankaauthorityManagementid));
        this.approvalTypeList = this.makeSelectBoxData(approvalTypeArray, this.preApprovalTypeList);
        // リストが複数件存在するとき承認部門のセレクトボックスを活性化
        if (this.approvalTypeList.length > 1) {
            this.slideTankaConditionInfo.controls['apprvAuthorityCode'].enable();
        } else if (this.approvalTypeList.length === 1) {
            this.slideTankaConditionInfo.controls['apprvAuthorityCode'].enable();
            this.slideTankaConditionInfo.controls['apprvAuthorityCode'].setValue(this.approvalTypeList[0].value);
        }
    }

    /** 
    * 検索ボタン押下処理
    * @memberof Sgkc031dSlideTankaSearchConditionComponent
    */
    onClickSearch(): void {
        this.onClickSearchEvent.emit();
    }

    /** 
     * クリアボタン押下処理
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    onClickClear(): void {
        this.onClickClearEvent.emit();
        this.setSelectBox();
    }

    /** 
     * 必須項目リスト押下処理
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    onSelectOpened(controlsName: string, opened: boolean) {
        // 必須項目の値を取得する。
        const targetValue = this.slideTankaConditionInfo.controls[controlsName].value;
        // 値が初期値と同じ かつ リストを閉じた場合はnullに更新する（バリデーションの発生）。
        if (targetValue === this.DEFAULT_SELECT_VALUE && !opened) {
            this.slideTankaConditionInfo.controls[controlsName].setValue(null);
        }
    }

    /** 
     * 検索ボタン表示処理
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    isSearchDisabled(): boolean {
        // 必須項目の値を取得する。
        const companycode = this.slideTankaConditionInfo.controls['companycode'].value;
        const energyClscode = this.slideTankaConditionInfo.controls['energyClscode'].value;
        const lpSalesformcode = this.slideTankaConditionInfo.controls['lpSalesformcode'].value;
        const apprvAuthorityCode = this.slideTankaConditionInfo.controls['apprvAuthorityCode'].value;

        // いずれかの値が初期値だった場合、検索ボタンが非活性となる。
        // エネルギー種別がLPガスの場合
        if (energyClscode === EnergyTypeCode.lpGas) {
            return companycode === this.DEFAULT_SELECT_VALUE
                || energyClscode === this.DEFAULT_SELECT_VALUE
                || lpSalesformcode === this.DEFAULT_SELECT_VALUE
                || apprvAuthorityCode === this.DEFAULT_SELECT_VALUE;
        } else {
            return companycode === this.DEFAULT_SELECT_VALUE
                || energyClscode === this.DEFAULT_SELECT_VALUE
                || apprvAuthorityCode === this.DEFAULT_SELECT_VALUE;
        }
    }

    /** 
     * 単価表承認権限取得APIで取得したデータをもとに、セレクトボックスデータを作成する
     * @param {string[]} targetList - 単価表承認権限取得APIで取得したリスト
     * @param {Array<PreSelectBox>} codeList - コード変換マスタから取得したデータ
     * @returns {SelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    makeSelectBoxData(targetList: string[], codeList: Array<PreSelectBox>): SelectBox[] {
        let filteredList: PreSelectBox[];
        let selectBox: SelectBox[]

        // 単価表承認権限取得APIで取得したデータとコード変換マスタから取得したデータを結合
        filteredList = codeList.filter(dto => targetList.includes(dto.value));
        // valueを基準に重複を排除
        filteredList = Array.from(
            new Map(filteredList.map(item => [item.value, item])).values()
        );
        // 項目並び順番で昇順ソート
        filteredList.sort((a, b) => {
            return a.hyojiRowTurn.localeCompare(b.hyojiRowTurn)
        });
        selectBox = filteredList.map(data => ({
            value: data.value,
            viewValue: data.viewValue,
        }))
        return selectBox;
    }

    /** 
     * セレクトボックスの初期値を設定する
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    setSelectBox(): void {
        // 会社コードの値を初期値にする。
        this.slideTankaConditionInfo.controls['companycode'].setValue(this.DEFAULT_SELECT_VALUE);
        // 会社コードの以降のフォームを非活性にする。
        this.slideTankaConditionInfo.controls['energyClscode'].disable();
        this.slideTankaConditionInfo.controls['lpSalesformcode'].disable();
        this.slideTankaConditionInfo.controls['apprvAuthorityCode'].disable();
        // 現在の年月を取得し適用年月(開始)にセットする
        // 年と月を抽出
        const year = this.timeApiService.convertDateToString(new Date()).substring(0, 4);
        const month = this.timeApiService.convertDateToString(new Date()).substring(4, 6);
        // フォームコントロールに初期値を設定
        this.slideTankaConditionInfo.get('applyYmStart')?.setValue(`${year}-${month}`);

        // 登録のとき項目を活性
        if (this.mode === DisplayMode.create) {
            this.slideTankaConditionInfo.controls['apprvStatuscode'].enable();
            this.statTypeList = [{ value: null, viewValue: '' }, // 先頭に空白行を追加
            ...this.preStatTypeList.map(data => ({
                value: data.value,
                viewValue: data.viewValue,
            }))];
        } else if (this.mode === DisplayMode.delete || this.mode === DisplayMode.approve) {
            // 取消・承認のとき初期表示に未承認を設定、項目を非活性
            this.slideTankaConditionInfo.controls['apprvStatuscode'].disable();
            // 未承認を先頭に並び替え
            const targetValue = SearchStat.mishonin;
            const targetItems = this.preStatTypeList.filter(item => item.value === targetValue);
            const otherItems = this.preStatTypeList.filter(item => item.value !== targetValue);
            this.preStatTypeList = [...targetItems, ...otherItems];
            this.statTypeList = [
                ...this.preStatTypeList.map(data => ({
                    value: data.value,
                    viewValue: data.viewValue,
                }))]
        } else if (this.mode === DisplayMode.read) {
            // 参照のとき項目を活性、初期表示に承認済を設定
            // 承認済を先頭に並び替え
            this.slideTankaConditionInfo.controls['apprvStatuscode'].enable();
            const targetValue = SearchStat.SHONINZUMI;
            const targetList = this.preStatTypeList.filter(item => item.value === targetValue);
            const otherList = this.preStatTypeList.filter(item => item.value !== targetValue);
            this.preStatTypeList = [...targetList, ...otherList];
            this.statTypeList = [
                ...this.preStatTypeList.map(data => ({
                    value: data.value,
                    viewValue: data.viewValue,
                })),
                { value: null, viewValue: '' } // 最後に空白行を追加
            ];
        }
        this.slideTankaConditionInfo.controls['apprvStatuscode'].setValue(this.statTypeList[0].value);
        // extractionConditionInformationListよりcompanycodeを取り出しcompanyTypeArrayに格納
        const companyTypeArray: string[] = this.extractionConditionInformationList.map(dto => dto.companycode);
        // 会社名にセレクトボックスデータを設定
        this.companyTypeList = this.makeSelectBoxData(companyTypeArray, this.preCompanyTypeList);
        // 会社名リストが複数件のと会社名のセレクトボックスを活性化
        if (this.companyTypeList.length > 1) {
            this.slideTankaConditionInfo.controls['companycode'].enable();
        } else if (this.companyTypeList.length === 1) {// 会社名リストが1件のときエネルギーのセレクトボックスを活性化、選択を確定
            this.slideTankaConditionInfo.controls['companycode'].enable();
            this.slideTankaConditionInfo.controls['companycode'].setValue(this.companyTypeList[0].value);
            this.onChangeCompany();
        }
    }

    /** 
     * コード変換マスタからセレクトボックスデータを取得する
     * @param {string} codeId - コードID
     * @returns {PreSelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc031dSlideTankaSearchConditionComponent
     */
    getSelectBoxFromCodeConversionMst(codeId: string): PreSelectBox[] {
        let preSelectBoxList: PreSelectBox[] = [];
        let codeList: CodeConversionMstDto[] = [];
        if (this.codeConversionMstMap.has(codeId)) {
            codeList = this.codeConversionMstMap.get(codeId);
            if (codeList) {
                codeList.forEach(data => {
                    const select: PreSelectBox = { value: data.userCode, viewValue: data.hyojiCont, hyojiRowTurn: data.hyojiRowTurn };
                    preSelectBoxList.push(select);
                })
            }
        }
        return preSelectBoxList;
    }
}
